import { pxToRem } from '../../utils';
export default (function (siteVars) {
    return {
        color: siteVars.gray02,
        backgroundColor: siteVars.white,
        activeColor: siteVars.black,
        activeBackgroundColor: siteVars.gray10,
        focusedBackgroundColor: siteVars.gray14,
        borderColor: siteVars.gray08,
        primaryActiveColor: siteVars.white,
        primaryActiveBackgroundColor: siteVars.brand08,
        primaryActiveBorderColor: siteVars.brand,
        primaryFocusedColor: siteVars.white,
        primaryFocusedBackgroundColor: siteVars.brand12,
        primaryBorderColor: siteVars.brand08,
        primaryHoverBorderColor: siteVars.gray08,
        primaryUnderlinedBorderColor: siteVars.gray08,
        circularRadius: pxToRem(999),
        lineHeightBase: siteVars.lineHeightBase,
    };
});
